import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { useQueries } from 'react-query';

import CurrentRaceList from '@/components/layouts/Race/Singlerace/CurrentRaceList';
import SubRotation from '@/components/layouts/Top/SubRotation';
import { RaceProgram } from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';
import { client } from '@/lib/microcms';
import { filterSalePrograms } from '@/lib/race';
import { BetDataList } from '@/modelTypes';

import {
  BlackSection,
  CompleteIcon,
  CompleteMessageWrapper,
  CurrentRaceTitle,
  CurrentRaceWrapper,
  Wrapper,
} from '../style';

interface BetPanelProps {
  racePrograms: RaceProgram[];
  betDataList: BetDataList;
}

const BetPanelComplete: React.FC<BetPanelProps> = ({
  racePrograms,
  betDataList,
}) => {
  const dateString = dayjst().format('YYYY-MM-DD');
  const [{ data: bannerData }] = useQueries([
    {
      queryKey: ['bannerdata', dateString],
      queryFn: async () => client.getObjectContent('bannerdata'),
      cacheTime: 60 * 10 * 1000, // 10分だけキャッシュする
    },
  ]);

  return (
    <Wrapper>
      <CompleteMessageWrapper>
        <p>投票が完了しました</p>
        <CompleteIcon />
      </CompleteMessageWrapper>
      {bannerData && isMobile && (
        <BlackSection>
          <SubRotation
            subRotations={bannerData.main}
            labelSuffix={'order'}
            isBgBlack={false}
          />
        </BlackSection>
      )}
      <CurrentRaceWrapper>
        <CurrentRaceTitle>他のレースを投票する</CurrentRaceTitle>
        <CurrentRaceList
          racePrograms={filterSalePrograms(racePrograms)}
          betDataList={betDataList}
          gap={8}
          gridTemplateColumns={[
            'repeat(auto-fit, minmax(118px, 1fr))',
            'repeat(auto-fit, minmax(118px, 1fr))',
            'repeat(auto-fit, minmax(118px, 1fr))',
            'repeat(auto-fit, minmax(118px, 1fr))',
            'repeat(4, 1fr)',
          ]}
        />
      </CurrentRaceWrapper>
      {bannerData && !isMobile && (
        <BlackSection>
          <SubRotation
            subRotations={bannerData.main}
            labelSuffix={'order'}
            isBgBlack={true}
          />
        </BlackSection>
      )}
    </Wrapper>
  );
};

export default BetPanelComplete;
